import { FETCH_TODOS } from "../actions/types";
import { FETCH_SCORE } from "../actions/types";
import { FETCH_PDFLIST } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_TODOS:
      return action.payload;
    case FETCH_SCORE:
      return action.payload;
    case FETCH_PDFLIST:
      return action.payload;
    default:
      return state;
  }
};
